import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../Layout/Layout';
import { AppButtonLink } from '../../components/AppButton/AppButton';
import BotGuideCard from './BotGuideCard';
import { BOT_GUIDES } from './botGuides';
import './Learn.css';

const Learn = () => {
    return (
        <Layout>
            <div className="learn-page">
                <header className="learn-page-header">
                    <span className="learn-page-eyebrow">Documentation</span>
                    <h1 className="learn-page-title">Bot setup guides</h1>
                    <p className="learn-page-subtitle">
                        Step-by-step instructions for every bot type in NeuraTrader.
                        Follow a guide, then open the setup page from your dashboard to go live.
                    </p>
                </header>

                <section className="learn-intro-card">
                    <h2 className="learn-intro-title">Before you build a bot</h2>
                    <ul className="learn-intro-list">
                        <li>
                            Create Binance API keys and connect them in <strong>Settings</strong> — follow the{' '}
                            <Link to="/learn/binance-api-keys" className="text-primary">Binance API Keys guide</Link>
                            {' '}(enable trading, never withdrawals).
                        </li>
                        <li>Confirm your plan includes enough <Link to="/pricing" className="text-primary">automation and monitor limits</Link>.</li>
                        <li>Fund your Binance wallet with enough balance for the order sizes you plan to use.</li>
                        <li>Start with logs enabled and small quantities while you validate behavior.</li>
                    </ul>
                </section>

                <div className="learn-guide-grid">
                    {BOT_GUIDES.map((guide) => (
                        <BotGuideCard key={guide.id} guide={guide} />
                    ))}
                </div>

                <section className="learn-intro-card learn-intro-card--spaced">
                    <h2 className="learn-intro-title">Which bot should I use?</h2>
                    <ul className="learn-intro-list">
                        <li><strong>Binance API Keys</strong> — required first; create trade-only keys and paste them in Settings.</li>
                        <li><strong>Grid Bot</strong> — ranging markets; automated orders between a lower and upper price.</li>
                        <li><strong>Scheduled Bot</strong> — time-based trades; DCA, rebalancing, or cron-driven execution.</li>
                        <li><strong>Algo Bot</strong> — rule-based strategies; monitors, conditions, and buy/sell automations combined.</li>
                    </ul>
                    <div className="learn-intro-cta">
                        <AppButtonLink to="/register" variant="primary" size="md">
                            Create free account
                        </AppButtonLink>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default Learn;